import React from "react";
import PropTypes from "prop-types";

import SavedOverviewContainer from "../../components/SavedOverview/container";

const SavedIndex = ({ data }) => {
  const articles = data.allSoetArticleNode.edges.map(edge => edge.node);
  return <SavedOverviewContainer articles={articles} />;
};

SavedIndex.propTypes = {
  data: PropTypes.shape({})
};

export default SavedIndex;

/**
 * We want to get all article previews
 */
// eslint-disable-next-line no-undef
export const articleQuery = graphql`
  query SavedArticleOverviewQuery {
    allSoetArticleNode(sort: { fields: [sortOrder], order: ASC }) {
      edges {
        node {
          id
          articleId
          path
          title
          titleNumber
          sortOrder
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/saved/index.js